export enum IntegrationTypeModel
{
  Webex = 10,
  Zoom = 20,
  GoToMeeting = 30,
  MsTeams = 40,
  GoToWebinar = 50,
  MsTeamsMeetings = 60
}
